/**
 * Typed access to the Vite-injected env vars.
 *
 * Fails loud at module init if either required var is missing — that's better
 * than a 404-spam runtime mystery later. The .env.example documents both.
 */

interface AppEnv {
  apiUrl: string;
  tonconnectManifestUrl: string;
  /** Where wallets bounce the user back to after signing inside Telegram. */
  twaReturnUrl: string | undefined;
  /** True when running in `vite dev`. */
  isDev: boolean;
}

function readEnv(): AppEnv {
  const apiUrl = import.meta.env.VITE_API_URL;
  const manifest = import.meta.env.VITE_TONCONNECT_MANIFEST_URL;
  const twaReturnUrl = import.meta.env.VITE_TWA_RETURN_URL;

  if (typeof apiUrl !== "string" || apiUrl.length === 0) {
    throw new Error(
      "VITE_API_URL is not set. Copy apps/web/.env.example to .env and fill it in.",
    );
  }
  if (typeof manifest !== "string" || manifest.length === 0) {
    throw new Error(
      "VITE_TONCONNECT_MANIFEST_URL is not set. Copy apps/web/.env.example to .env and fill it in.",
    );
  }

  return {
    apiUrl: apiUrl.replace(/\/+$/, ""),
    tonconnectManifestUrl: manifest,
    twaReturnUrl:
      typeof twaReturnUrl === "string" && twaReturnUrl.length > 0
        ? twaReturnUrl
        : undefined,
    isDev: import.meta.env.DEV,
  };
}

export const env: AppEnv = readEnv();
